import { FC } from "react";
import { useAppSelector } from "../../../hooks/reduxHooks";
import ProductsList from "../../../components/ProductsList";

const Products: FC = () => {
    const {isAdmin} = useAppSelector((state) => state.userReducer)
    return (isAdmin ? (<ProductsList />) : (<>Missing Permissions</>))
}
export default Products;